export default "__VITE_ASSET__CrD8FO4$__"